import { render } from "./Logo.vue?vue&type=template&id=30d31dac"
const script = {}

import exportComponent from "D:\\Project\\YBPM\\Project\\sch-fe-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__